export const clientipsRoutes = {
  path: "/clientips",
  to: "/clientips",
  icon: "mdi-file-document-multiple-outline",
  activeRoutes: ["clientips"],
  meta: {
    title: "clientIps",
  },
  showInMenu: true,
  order: 8,
  component: () => import("@/views/clientips"),
  children: [
    {
      path: "/",
      component: () => import("@/views/clientips"),
      name: "clientips",
      icon: "mdi-file-document-multiple-outline",
      to: "/clientips",
      allowed: false,
      meta: {
        title: "clientips",
      },
    },
    {
      path: "/clientips",
      name: "Clientips",
      component: () => import("@/views/clientips"),
    },
  ],
};
